module.exports = __webpack_public_path__ + "static/use_bold_text_example-d53d84df64c4dba32d5d831627f5ab73.png";